export const returnMessageFormMixin = {
  data() {
    return {
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
    };
  },
  methods: {
    logMessageForm(res) {
      this.alert = {
        color: 'alert-success',
        icon: 'fas fa-check fa-lg',
        message: `${res.data.message}`,
        reason: '',
      };
    },
    logMessageFormFailed(error) {
      let errorMessage;
      const errorsKeys = Object.keys(error.data.errors || []);
      if (error.data.errors && errorsKeys.length > 0) {
        errorMessage = error.data.errors[errorsKeys[0]][0];
      } else {
        errorMessage = error.data.message;
      }
      if (!errorMessage) {
        errorMessage = error.data.error;
      }
      this.alert = {
        color: 'alert-danger',
        icon: 'fas fa-times-hexagon',
        message: `${errorMessage}`,
        reason: '',
      };
    },
    logMessageFormWarning(error) {
      let errorMessage;
      const errorsKeys = Object.keys(error.data.errors || []);
      if (error.data.errors && errorsKeys.length > 0) {
        errorMessage = error.data.errors[errorsKeys[0]][0];
      } else {
        errorMessage = error.data.message;
      }
      this.alert = {
        color: 'alert-warning',
        icon: 'fas fa-exclamation-circle',
        message: `${errorMessage}`,
        reason: '',
      };
    },
    messageWaitingSave() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Aguarde, salvando os dados!',
        reason: '',
      };
    },
  },
};
